import { render, staticRenderFns } from "./reading.vue?vue&type=template&id=0baf265e"
import script from "./reading.ts?vue&type=script&lang=js&external"
export * from "./reading.ts?vue&type=script&lang=js&external"
import style0 from "./reading.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports